import { IsNonZeroNumber } from './HelperMath'

export type Duration = {
    hours: number
    minutes: number
    seconds: number
}

export type DurationKey = keyof Duration

export function HoursToMinutes(hours: number): number {
    return Math.trunc(hours) * 60
}

export function HoursToSeconds(hours: number): number {
    return MinutesToSeconds(HoursToMinutes(hours))
}

export function MinutesToHours(minutes: number): number {
    return Math.trunc(minutes / 60)
}

export function MinutesToSeconds(minutes: number): number {
    return Math.trunc(minutes) * 60
}

export function SecondsToHours(seconds: number): number {
    return Math.trunc(seconds / 3600)
}

export function SecondsToMinutes(seconds: number): number {
    return Math.trunc(seconds / 60)
}

export function SecondsToDuration(seconds: number): Duration {
    seconds = IsNonZeroNumber(seconds) ? seconds : 0

    return {
        hours: SecondsToHours(seconds),
        minutes: SecondsToMinutes(RemainingSecondsAfterHours(seconds)),
        seconds: RemainingSecondsAfterMinutes(seconds),
    }
}

export function DurationToSeconds(duration: Duration): number {
    return HoursToSeconds(duration.hours) + MinutesToSeconds(duration.minutes) + duration.seconds
}

export function MinutesToMilliseconds(minutes: number): number {
    return MinutesToSeconds(minutes) * 1000
}

export function TimeToString(hours: number, minutes: number, seconds: number): string {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export function RemainingMinutesAfterHours(minutes: number): number {
    return minutes - MinutesToHours(minutes) * 60
}

export function RemainingSecondsAfterHours(seconds: number): number {
    return seconds - SecondsToHours(seconds) * 3600
}

export function RemainingSecondsAfterMinutes(seconds: number): number {
    return seconds - SecondsToMinutes(seconds) * 60
}
